<template>
  <div>
    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.attachment="{item}">
        <slot name="attachment" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/skillMaint";
export default {
  props: {
    empCode: {
      default: null,
      type: String
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Skill",
        value: "skillDesc",
        sortable: false
      },
      {
        text: "Attachment",
        value: "attachment",
        sortable: false
      }
    ]
  }),
  methods: {
    getByEmpCode(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${empCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.success(response.data.message);
        });
    }
  },
  created() {
    this.getByEmpCode(this.empCode);
  },
  watch: {
    empCode(val) {
      this.getByEmpCode(val);
    }
  }
};
</script>